import GenericMessage from 'components/errors/generic-message';

const ResetPasswordDone = () => (
  <GenericMessage title="Password Successfully Reset!" desc="You can now login using your new password." />
);

export default ResetPasswordDone;
